import {Card} from "@mui/material";
import DashboardLayout from "../LayoutContainers/DashboardLayout";
import MDBox from "../../components/MDBox";
import Footer from "../Footer";
import Meta from "../common/Meta";

export default function Privacy(props) {

  return (<DashboardLayout>

      <Meta pageTitle={'Privacy Policy'}/>

      <MDBox py={3}>
        <Card>
          <MDBox p={3}>
            <h5 className={'mb-3'}>
              PRIVACY POLICY
            </h5>

            <p>Introduction</p>

            <p>We are Play Space Brain, LLC ("Company," "we," "us," or "our"), and our address is 201 Bolinas Court,
              Chapel Hill, NC 27517. We operate the website located at playspacebrain.com (the "Website") and the mobile
              app known as Play Space Brain (the "App"). This Privacy Policy informs you of our policies regarding the
              collection, use, and disclosure of information from users of the Website, the App, and/or any related
              services, sales, and events (collectively, the "Sites"). If you have questions about this Privacy Policy
              or our privacy practices, email us at Support@playspacebrain.com. By using any of the Sites, you accept
              and agree to everything set forth in this Privacy Policy. We may update this Privacy Policy from time to
              time, and the updated version will be effective 30 days after we post it, during which time you may review
              the changes. If you continue to use the Sites after the changes become effective, you accept and agree to
              the updated Privacy Policy. We encourage you to review this Privacy Policy frequently.
            </p>
            <p>We are Play Space Brain, LLC ("Company," "we," "us," or "our"), and our address is 201 Bolinas Court,
              Chapel Hill, NC 27517. We operate the website located at playspacebrain.com (the "Website") and the mobile
              app known as Play Space Brain (the "App"). This Privacy Policy informs you of our policies regarding the
              collection, use, and disclosure of information from users of the Website, the App, and/or any related
              services, sales, and events (collectively, the "Sites"). If you have questions about this Privacy Policy
              or our privacy practices, email us at Support@playspacebrain.com. By using any of the Sites, you accept
              and agree to everything set forth in this Privacy Policy. We may update this Privacy Policy from time to
              time, and the updated version will be effective 30 days after we post it, during which time you may review
              the changes. If you continue to use the Sites after the changes become effective, you accept and agree to
              the updated Privacy Policy. We encourage you to review this Privacy Policy frequently.
            </p>Information We Collect

            <p>We are Play Space Brain, LLC ("Company," "we," "us," or "our"), and our address is 201 Bolinas Court,
              Chapel Hill, NC 27517. We operate the website located at playspacebrain.com (the "Website") and the mobile
              app known as Play Space Brain (the "App"). This Privacy Policy informs you of our policies regarding the
              collection, use, and disclosure of information from users of the Website, the App, and/or any related
              services, sales, and events (collectively, the "Sites"). If you have questions about this Privacy Policy
              or our privacy practices, email us at Support@playspacebrain.com. By using any of the Sites, you accept
              and agree to everything set forth in this Privacy Policy. We may update this Privacy Policy from time to
              time, and the updated version will be effective 30 days after we post it, during which time you may review
              the changes. If you continue to use the Sites after the changes become effective, you accept and agree to
              the updated Privacy Policy. We encourage you to review this Privacy Policy frequently.
            </p>We may collect the following information from you as you explore and use the Sites:

            <ul>
              <li>Personal information you provide to us, such as your name, address, phone number, email address, date
                of birth, age, and login credentials
              </li>
              <li>Payment data (such as credit card information), which is stored by our payment processor</li>
              <li>Social media login data</li>
              <li>Your IP address, browser and device characteristics, operating system, language preferences, referring
                URLs, device name, country, and location
              </li>
              <li>Site usage patterns, page visit data, purchase history</li>
            </ul>

            <p>
              We collect information directly from you via your use of the Website and the App. We also may collect
              limited information about you from public databases, marketing platforms, social media platforms, and
              other
              third-party sources. If you choose to log in using a social media account, we will receive certain
              information about you from your social media provider. The profile information we receive may vary
              depending
              on the social media provider concerned, but will often include your name, e-mail address, friends list,
              profile picture as well as other information you choose to make public.
            </p>
            <p>We collect some of the information described above through the use of "cookies," "pixels," "web beacons,"
              and similar technologies. You can control these through your browser settings and can opt-out of certain
              types of tracking by adjusting your device or browser preferences.

            </p>
            <p>Use of Your Information

            </p>
            <p>We use the information that we collect from you to provide our services to you. In addition, we may use
              the
              information for one or more of the following purposes:
            </p>
            <ul>
              <li>To fulfill our legal obligations</li>
              <li>To send you marketing and promotional communications</li>
              <li>To send you information about new services and features</li>
              <li>To notify you of changes in our terms of use</li>
              <li>To deliver targeted advertising to you</li>
              <li>To request feedback from you</li>
              <li>To enable user-to-user communication</li>
              <li>To enforce our terms of use</li>
              <li>For data and usage analysis, determining the effectiveness of our services or promotional campaigns,
                and
                to evaluate and improve the Sites
              </li>
            </ul>

            <p>We will only keep your personal information for as long as it is necessary for the purposes set out in
              this
              Privacy Policy unless a longer retention period is required or permitted by law (such as tax, accounting,
              or
              other legal requirements). When we have no ongoing legitimate business need to retain your personal
              information, we will either delete or anonymize it, or, if this is not possible (for example, because your
              personal information has been stored in backup archives), then we will securely store your personal
              information and isolate it from any further processing until deletion is possible.
            </p>
            <p>
              We have implemented technical and organizational security measures designed to protect the security of any
              personal information we collect. Nothing on the Internet is 100% secure. Transmission of personal
              information to and from the Sites is at your own risk. You should only access the Sites within a secure
              environment.

            </p>
            <p>Sharing of Your Information

            </p>
            <p>We may share your information with third parties on any of the following bases:</p>
            <ul>
              <li>You have given us consent to do so</li>
              <li>It is reasonably necessary for us to achieve a legitimate business purpose</li>
              <li>We must do so to meet our contractual obligations to you</li>
              <li>We are legally required to do so</li>
              <li>To investigate, prevent, or take action regarding suspected fraud, illegal activities, or threats to a
                person’s safety
              </li>
              <li>When our third-party vendors, service providers, contractors, or agents require access to your
                information
                to perform work for us
              </li>
              <li>In the negotiation or execution of a merger, sale, financing, loan, or acquisition</li>
              <li>To enable third-party advertisers or business partners to serve ads to you or offer you certain
                products,
                services, or promotions
              </li>
              <li>With our affiliates (parent companies, related companies, and subsidiaries)</li>
              <li>Other users may be able to view your profile information if you choose to interact with them</li>
            </ul>
            <p>You may opt-out of having your data collected or shared with others (except when required to meet our
              contractual obligations to you, we are legally obligated to do so, or to investigate, prevent, or take
              action regarding suspected fraud, illegal activities, or threats to a person’s safety) by emailing us at
              Support@playspacebrain.com. Note that upon receiving your request we will cease collecting and sharing
              your
              data, however, your data may not be completely or comprehensively removed from our systems.

            </p>
            <p>Equality in Service and Price

            </p>
            <p>Our prices and services are not affected by whether you opt-out of having your data collected our shared.

            </p>
            <p>Third-Party Websites

            </p>
            <p>The Sites may contain advertisements from third parties that are not affiliated with us and which may
              link
              to other websites, online services, or mobile applications. We cannot guarantee the safety and privacy of
              data you provide to any third parties. Any data collected by third parties is not covered by this Privacy
              Policy. We are not responsible for the content or privacy and security practices and policies of any third
              parties, including other websites, services, or applications that may be linked to or from the Sites.

            </p>
            <p>Geographic and Age-Specific Privacy Rights

            </p>
            <p>The Sites are not directed toward children under the age of 18, and children under the age of 18 are not
              permitted to join or use the Sites. We do not knowingly collect personal information from children under
              the
              age of 18.

            </p>
            <p>The Sites are not directed toward European citizens or residents, and European citizens or residents are
              not
              permitted to join or use the Sites. We do not knowingly collect information from European citizens or
              residents.

            </p>
            <p>Under the California Consumer Privacy Act (CCPA), California residents have specific rights regarding
              their
              personal information, including: (1) The right to know about personal information collected, disclosed, or
              sold; (2) The right to request deletion of personal information; (3) The right to opt-out of the sale of
              personal information; and (4) The right to non-discrimination for exercising their CCPA rights. California
              residents may also request and obtain from us, once a year and free of charge, information about
              categories
              of personal information (if any) we disclosed to third parties for direct marketing purposes and the names
              and addresses of all third parties with which we shared personal information in the immediately preceding
              calendar year. If you are a California resident and would like to make such a request, please submit your
              request in writing to us at <u>support@playspacebrain.com</u>.
            </p>

          </MDBox>
        </Card>
      </MDBox>

      <Footer mt={5}/>

    </DashboardLayout>);
}